import React from "react";

import styles from './BoxCheckbox.module.css'

const BoxCheckbox = props => {
  
  const {label, status, onChange, className, name, ...other} = props
  return(
    <label className={`${styles.BoxCheckbox} ${className ? className : ''}`} {...other}>
      <input type="checkbox" checked={status} name={name} onChange={onChange} {...props} />
      <div className={styles.visualCheckbox}>
        <span className={styles.label}>{label}</span>
      </div>
    </label>
  )
}

export default BoxCheckbox 